import $ from 'jquery';
import Tips from '../Tips';
/* ===============================================================
  MyAccount
=============================================================== */
class MyAccount {
    constructor() {
        this.tip = new Tips();
        this.events();
    }

    events() {
        this.woocommerceNotice();
        this.dashboardNavigationToggle();
        this.inputFocus();
        this.pageSwitching();
        this.checkPassword();
        this.changeAvatar();
    }

    woocommerceNotice() {
        let current = this;
        $(window).on('load', function () {
            let wcNoticeWrapper = $('.woocommerce-notices-wrapper');
            if (wcNoticeWrapper.children('ul').length > 0) {
                current.tip.createTip(
                    'error',
                    wcNoticeWrapper.find('li').text(),
                );
            } else if (wcNoticeWrapper.text()) {
                current.tip.createTip('info', wcNoticeWrapper.text());
            }
        });
    }
    // Enable toggle of dashboard menu in mobile and control in mobile and desktop window size
    dashboardNavigationToggle() {
        let MyAccount = $('.irantheme-myaccount');
        if (MyAccount.length) {
            let navWrapper = $(MyAccount).find(
                '.irantheme-woocommerce-myaccount-navigation-holder',
            );
            let navToggle = $(MyAccount)
                .find('.irantheme-woocommerce-myaccount-head-navigation-holder')
                .children(
                    '.irantheme-woocommerce-myaccount-navigation-mobile-trigger',
                );

            const mobileMediaQuery = window.matchMedia('(max-width: 767.98px)');

            function handleScreenChange(e) {
                if (!e.matches) {
                    // Desktop
                    navWrapper.stop(true, true).show().removeClass('active');
                    navWrapper.css('display', ''); // Reset style
                } else {
                    // Mobile
                    if (!navWrapper.hasClass('active')) {
                        navWrapper.stop(true, true).hide();
                    } else {
                        navWrapper.stop(true, true).show();
                    }
                }
            }

            navToggle.on('click', function (e) {
                e.preventDefault();

                // Only in mobile
                if (!mobileMediaQuery.matches) return;

                // Prevent simultaneous animation
                if (navWrapper.is(':animated')) return;

                if (navWrapper.hasClass('active')) {
                    navWrapper.slideUp(250, function () {
                        navWrapper.removeClass('active');
                    });
                } else {
                    navWrapper.slideDown(250, function () {
                        navWrapper.addClass('active');
                    });
                }
            });

            mobileMediaQuery.addEventListener('change', handleScreenChange);

            // Run on first launch
            handleScreenChange(mobileMediaQuery);
        }
    }
    // Change avatar input clickable
    changeAvatar() {
        $('.irantheme-myaccount-edit-account-avatar-content-actions-change').on(
            'click',
            function (e) {
                $(this).siblings('#irantheme_input_avatar').trigger('click');
            },
        );
        $('.irantheme-myaccount-edit-account-avatar-content-actions-delete').on(
            'click',
            function (e) {
                let img = $(this)
                    .parents('.irantheme-myaccount-edit-account-avatar-holder')
                    .find('.irantheme-myaccount-edit-account-avatar-img img');
                let input = $(this).siblings('#irantheme_input_avatar');
                let inputHidden = $(this).siblings(
                    '#irantheme_input_avatar_hidden',
                );
                inputHidden.val('defaultAvatar');
                input.prop('disabled', true);
                inputHidden.prop('disabled', false);
                img.attr('src', input.attr('data-default'));
            },
        );
        $(
            '.irantheme-myaccount-edit-account-avatar #irantheme_input_avatar',
        ).on('change', function (e) {
            let input = $(this);
            let file = $(input)[0].files[0];
            if (file) {
                let reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = function (e) {
                    // browser completed reading file - display it
                    $('.irantheme-myaccount-edit-account-avatar-img img').attr(
                        'src',
                        e.target.result,
                    );
                };
            }
        });
    }

    // Change border color of input holders on focus and blur
    inputFocus() {
        $('.irantheme-login-input').on('focus', function (e) {
            let parentInput = $(e.target).parents(
                '.password-input, .irantheme-login-input-icon-holder',
            );
            parentInput.addClass('active');
        });
        $('.irantheme-login-input').on('blur', function (e) {
            let parentInput = $(e.target).parents(
                '.password-input, .irantheme-login-input-icon-holder',
            );
            parentInput.removeClass('active');
        });
    }
    // Switch between signIn and signUp page
    pageSwitching() {
        // Get login type
        let loginType = $('.irantheme-myaccount-login-pages').attr('data-type');

        $('#irantheme_myaccount_registration_toggle').on('click', function (e) {
            $('.irantheme-login-content').fadeOut(150);
            setTimeout(() => {
                $('.irantheme-register-content')
                    .fadeIn(150)
                    .css('display', 'flex');
            }, 150);
        });
        $('#irantheme_myaccount_login_toggle').on('click', function (e) {
            $('.irantheme-register-content').fadeOut(150);
            setTimeout(() => {
                if (loginType == 'otp') {
                    $('.irantheme-login-otp-content')
                        .fadeIn(150)
                        .css('display', 'flex');
                } else if (loginType == 'traditional') {
                    $('.irantheme-login-content')
                        .fadeIn(150)
                        .css('display', 'flex');
                }
            }, 150);
        });
        $('#irantheme_show_otp_login').on('click', function (e) {
            $('.irantheme-login-content').fadeOut(150);
            setTimeout(() => {
                $('.irantheme-login-otp-content')
                    .fadeIn(150)
                    .css('display', 'flex');
            }, 150);
        });
    }
    // Check strength password
    checkPassword() {
        let registerForm = $('.irantheme-register-content-form');
        $('.irantheme-registration-password-input').on(
            'keyup input',
            function (e) {
                let submitBtn = $('.irantheme-register-content-form-submit');
                let leastCharFlag = $('.irantheme-register-password-hint').find(
                    '.password-contain-least-char',
                );
                let letterCharFlag = $(
                    '.irantheme-register-password-hint',
                ).find('.password-contain-letter-char');
                let numberCharFlag = $(
                    '.irantheme-register-password-hint',
                ).find('.password-contain-number-char');
                let symbolCharFlag = $(
                    '.irantheme-register-password-hint',
                ).find('.password-contain-symbol-char');
                let validations = [
                    {
                        pattern: /.{8,}/,
                        issue: 'least',
                    },
                ];
                if (registerForm.hasClass('irantheme-registration-pwd-check')) {
                    validations.push(
                        {
                            pattern: /[a-z]/,
                            issue: 'lowercase',
                        },
                        {
                            pattern: /[A-Z]/,
                            issue: 'uppercase',
                        },
                        { pattern: /[0-9]/, issue: 'number' },
                        { pattern: /[$@$!%*#?&]/, issue: 'symbol' },
                    );
                }
                let pwd = $('.irantheme-registration-password-input').val();
                let validationIssues = validations
                    .filter((validation) => {
                        return !pwd?.match?.(validation.pattern);
                    })
                    .map((validation) => validation.issue);
                $('.irantheme-register-password-hint')
                    .find('.irantheme-register-password-hint-item-text')
                    .addClass('complete');
                if (validationIssues.length > 0) {
                    if (!submitBtn.hasClass('disabled')) {
                        submitBtn.addClass('disabled');
                        submitBtn.prop('disabled', true);
                    }
                    validationIssues.forEach((typeName) => {
                        if (
                            typeName == 'lowercase' ||
                            typeName == 'uppercase'
                        ) {
                            letterCharFlag.removeClass('complete');
                        }
                        if (typeName == 'number') {
                            numberCharFlag.removeClass('complete');
                        }
                        if (typeName == 'symbol') {
                            symbolCharFlag.removeClass('complete');
                        }
                        if (typeName == 'least') {
                            leastCharFlag.removeClass('complete');
                        }
                    });
                } else {
                    submitBtn.prop('disabled', false);
                    submitBtn.removeClass('disabled');
                }
            },
        );
    }
}
export default MyAccount;
